<script lang="ts">
  import Day from "./Day.svelte";
  import type { DateTime } from "./lib/date-time";
  import type { SelectionRange } from "./lib/range";
  import type { Availabilities } from "./availability/availability-provider";
  import type { Calender, Panel } from "./lib/calender";
  import { DatePickerTranslations } from "./DatePicker.i18n";

  export let panel: Panel;
  export let calender: Calender;
  export let language: string;

  export let today: DateTime;
  export let selection: SelectionRange;
  export let availabilities: Availabilities;

  $: T = DatePickerTranslations(language);
</script>

<div class="lrs-panel-weeks">
  <div class="lrs-week">
    <span class="lrs-week-number" />
    {#each calender.weekDays as weekDay}
      <div class="lrs-day lrs-weekday">
        <span class="lrs-text">{T.get("getWeekDayName", weekDay)}</span>
      </div>
    {/each}
  </div>

  {#each panel.weeks as week}
    <div class="lrs-week">
      <span class="lrs-week-number">{week.weekNumber}</span>

      {#each week.days as day}
        <Day {day} {availabilities} {selection} {language} {today} />
      {/each}
    </div>
  {/each}
</div>

<style lang="scss" global>
  .lrs-panel-weeks {
    display: flex;
    flex-flow: column;
    padding: 0.5em;
    min-height: calc((7 * 3em) + (7 * 2px) + 1em);

    .lrs-week {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      margin-bottom: 2px;
    }

    .lrs-week-number {
      width: 3ch;
      opacity: 0.6;
      text-align: center;
    }

    .lrs-weekday {
      pointer-events: none;

      .lrs-text {
        font-weight: bold;
      }
    }
  }
</style>
